import styled from 'styled-components';
import { PriceMixin } from '@qover/typography';

export const Container = styled.div`
  align-items: flex-end;
  background-color: ${props => props.theme.colors.textQuote(0.05)};
  color: ${props => props.theme.colors.textQuote()};
  padding: 20px;

  &.light {
    background-color: ${props => props.theme.colors.cardBackground(0.9)};
  }

  &.shadowed {
    box-shadow: 0 2px 4px 0 ${props => props.theme.colors.textQuote(0.15)};
    z-index: 2;
    position: relative;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const PriceContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  padding-right: 20px;
  width: auto;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    justify-content: flex-start;
    padding-right: 0;
    width: 100%;
  }
`;

export const Price = styled.span`
  ${PriceMixin};

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    font-size: 1.625rem;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 960px;
  width: 100%;
  flex-direction: column-reverse;
  &.reverse {
    flex-direction: column;
  }
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1 1 auto;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    padding-right: 0;
  }
`;

export const Option = styled.div`
  align-items: center;
  display: flex;
  max-width: 245px;
  padding: 2px 0;
  width: 100%;

  :nth-child(even) {
    width: auto;
  }

  svg {
    margin-right: 10px;

    g,
    path {
      fill: ${props => props.theme.colors.textQuote()};
      fill-opacity: 1;
    }
  }
`;

export const PriceRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 160px;

  > * + * {
    margin-top: 10px;
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    flex-direction: row-reverse;

    > * + * {
      margin-top: 0;
      margin-right: 10px;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 500px;
  padding: 10px 20px 0 0;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    padding: 15px 20px 0 0;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.S}) {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const EmailModalButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: center;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    justify-content: flex-end;
  }
`;
